import React, { MouseEvent, KeyboardEvent } from "react";
import styles from "./machines-cancel-request-disconnect-support-modal.scss";
import { Button } from "@src/components/atoms/buttons/button/button";
import { FlexRowContainer } from "@src/components/templates/layouts/flex-row-container/flex-row-container";
import closeIcon from "@src/assets/svg/close-icon.svg";
import { HorizontalSeparator } from "@src/components/atoms/horizontal-separator/horizontal-separator";
import { IconButton } from "@src/components/atoms/buttons/icon-button/icon-button";
import { MachinesListSupportSessionsCancelRequestModalTextTypes } from "@common/types/machines-list-types";

const cssClassName =
  "machines-cancel-request-disconnect-support-modal";

interface MachinesCancelRequestDisconnectSupportModalPropsTypes {
  onCancel: (e: MouseEvent | KeyboardEvent) => void;
  modalTexts: MachinesListSupportSessionsCancelRequestModalTextTypes;
}

export const MachinesCancelRequestDisconnectSupportModal = ({
  onCancel,
  modalTexts: texts,
}: MachinesCancelRequestDisconnectSupportModalPropsTypes) => {
  const handleBackdropClick = (e: MouseEvent) => {
    if (e.target === e.currentTarget) {
      onCancel(e);
    }
  };

  const handleBackdropKeyDown = (e: KeyboardEvent) => {
    if (e.key === "Enter" || e.key === " " || e.key === "Spacebar") {
      if (e.target === e.currentTarget) {
        onCancel(e);
      }
    }
  };

  return (
    <div
      className={styles[cssClassName]}
      role="button"
      tabIndex={0}
      aria-label="Close modal"
      onClick={handleBackdropClick}
      onKeyDown={handleBackdropKeyDown}
    >
      <div className={styles[`${cssClassName}__container`]}>
        <div className={styles[`${cssClassName}__header`]}>
          <h2 className={styles[`${cssClassName}__title`]}>{texts.title}</h2>

          <div className={styles[`${cssClassName}__close-btn`]}>
            <IconButton fun={onCancel} icon={closeIcon} />
          </div>
        </div>

        <HorizontalSeparator verticalMargin={12} />

        <div className={styles[`${cssClassName}__content`]}>
          <p className={styles[`${cssClassName}__message`]}>{texts.message}</p>
        </div>

        <HorizontalSeparator verticalMargin={12} />

        <div className={styles[`${cssClassName}__actions`]}>
          <FlexRowContainer horizontalGap={12}>
            <Button
              fun={onCancel}
              text={texts.cancelButton}
              variant={["cancel-button", "color-blue"]}
            />
          </FlexRowContainer>
        </div>
      </div>
    </div>
  );
};
